/**
 * @Author: Anandp
 * @Date:   2024-04-17 18:40:50
 * @Last Modified by:   Anandp
 * @Last Modified time: 2024-12-23 21:45:52
 */
import { Url } from "src/config";
import axios from "axios";
const UserapiService = {
  //create a new user
  addUser: async (userData) => {
    try {
      let response = await axios.post(`${Url}/module/user`, userData);
      return response.data;
    } catch (error) {
      console.log(error.response.data.message, 'error');
      return error.response.data;
    }
  },
  //pagination
  userPagination: async (accessToken, currentPage, limit, searchDataValue) => {
    let searchData = "";
    if (searchDataValue && searchDataValue.length > 2) {
      searchData = `&search=${searchDataValue}`;
    }
    try {
      let response = await axios.get(
        `${Url}/customer/paginationUser?page=${currentPage}&limit=${limit}${searchData}`,
        {
          headers: {
            "access-token": accessToken,
          }
        }
      );
      return response.data;
    } catch (error) {
      console.log(error.message);
    }
  },

  //get all users
  getAllusers: async (accessToken, id) => {
    try {
      const response = await axios.get(`${Url}/customer/getUsers`, {
        headers: {
          "access-token": accessToken,
        }
      });
      return response.data;
    } catch (error) {
      return error
    }
  },
  //get all users
  getUsers: async () => {
    try {
      const response = await axios.get(`${Url}/module/user`);
      return response.data;
    } catch (error) { }
  },
  //get-a-single user
  getSelectedtUser: async (userId) => {
    try {
      const response = await axios.get(`${Url}/module/user?id=${userId}`);
      return response.data;
    } catch (error) {
      console.log(error);
    }
  },
  //check is user already exist
  checkEmail: async (email) => {
    let body = {
      email,
    };
    try {
      // eslint-disable-next-line no-unused-vars
      const response = await axios.post(`${Url}/module/user/check`, body);
      // return response.data;
    } catch (error) {
      return error.response.data.message;
    }
  }, //edit-a-user
  editUser: async (accessToken,userId, editedValues) => {
    try {
      const response = await axios.put(
        `${Url}/customer/updateUserEntityCode`,
        editedValues,
        {
          headers: {
            "access-token": accessToken,
          }
        }
      );
      return response.data;
    } catch (error) { }
  },
  //update user entity code
  updateUserEntityCode: async (data) => {
    const accessToken = sessionStorage.getItem("accessToken");
    try {
      const response = await axios.put(
        `${Url}/customer/updateUserEntityCode`,
        data,
        {
          headers: {
            "access-token": accessToken,
          }
        }
      );
      return response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return error.response.data;
      }
      return { success: false, message: 'Network error' };
    }
  },
};
export default UserapiService;
